import React from "react";

export default function IconExpand({ color = "currentColor", ...rest }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M13.3333 3.3335H16.6666M16.6666 3.3335V6.66683M16.6666 3.3335L11.6666 8.3335M6.66659 16.6668H3.33325M3.33325 16.6668V13.3335M3.33325 16.6668L8.33325 11.6668"
        stroke={color}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

